import { useContext } from 'react';
import LoaderContext from 'contexts/LoaderContext';

// ==============================|| CONFIG - HOOKS ||============================== //

export default function useLoader() {
  return useContext(LoaderContext);
}
